<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 32"
  >
    <title>heart</title>
    <path
      fill="none"
      stroke-linejoin="miter"
      stroke-linecap="butt"
      stroke-miterlimit="4"
      stroke-width="2.6667"
      :stroke="color"
      d="M14.879 26.436l-0.002-0.002c-3.71-3.3-6.672-5.942-8.724-8.405-2.037-2.445-3.019-4.532-3.019-6.696 0-3.516 2.792-6.283 6.433-6.283 2.066 0 4.064 0.95 5.357 2.429l1.076 1.23 1.076-1.23c1.293-1.478 3.292-2.429 5.357-2.429 3.642 0 6.433 2.767 6.433 6.283 0 2.164-0.982 4.251-3.019 6.696-2.052 2.462-5.015 5.105-8.724 8.405l-0.002 0.002-0.168 0.15c-0.542 0.484-1.362 0.484-1.905 0l-0.168-0.15z"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgTalk',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>

<style>

</style>
